/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneScrollArticleLabel as ResolvedStandaloneScrollArticleLabel } from 'base/components/standalone/ScrollArticleLabel';

export const ScrollArticleLabel: typeof ResolvedStandaloneScrollArticleLabel = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneScrollArticleLabel {...props} />
        </ErrorBoundary>
    );
});

export type ScrollArticleLabelProps = PropsFromComponent<typeof ScrollArticleLabel>;

/** @deprecated Use slot architecture instead */
export const ScrollArticleLabelWith = (extras: DynamicStandaloneExtras): typeof ScrollArticleLabel => {
    return function ScrollArticleLabel(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ScrollArticleLabel');
        return <ResolvedStandaloneScrollArticleLabel {...mergeProps({ options: { theme } }, props)} />;
    }
}